import "./index.css";
import { useDictionary } from "@/hooks/useDictionary";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import { SearchBox } from "@/components/SearchBox";
import { SentenceTokenView } from "@/components/SentenceTokenView";
import { SearchResultList } from "@/components/SearchResultList";
import { config } from "@/lib/config";

export function App() {
  const {
    isLoading,
    error,
    entryCount,
    searchQuery,
    setSearchQuery,
    searchMode,
    tokens,
    filteredResults,
    filter,
    setFilter,
    jyutpingCount,
    englishCount,
  } = useDictionary();

  if (isLoading) {
    return <LoadingOverlay message="Loading dictionary..." />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-2">
            Failed to load dictionary
          </h1>
          <p className="text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  const showTokenView = searchMode === "chinese" && tokens && tokens.length > 0;
  const showResultList = !showTokenView && filteredResults.length > 0;
  const showNoResults =
    searchQuery.trim() && !showTokenView && filteredResults.length === 0;

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2">{config.appName}</h1>
          <p className="text-muted-foreground">
            Search {entryCount.toLocaleString()} {config.language} entries
          </p>
        </header>

        {/* Search Box */}
        <div className="mb-8">
          <SearchBox
            value={searchQuery}
            onChange={setSearchQuery}
            searchMode={searchMode}
            filter={filter}
            onFilterChange={setFilter}
            jyutpingCount={jyutpingCount}
            englishCount={englishCount}
          />
        </div>

        {/* Results */}
        <div className="space-y-6">
          {showTokenView && (
            <SentenceTokenView tokens={tokens} onCharacterClick={setSearchQuery} />
          )}

          {showResultList && (
            <SearchResultList
              results={filteredResults}
              query={searchQuery}
              onCharacterClick={setSearchQuery}
            />
          )}

          {showNoResults && (
            <div className="text-center text-muted-foreground py-8">
              No results found for "{searchQuery}"
            </div>
          )}

          {!searchQuery.trim() && (
            <div className="text-center text-muted-foreground py-12">
              <p className="mb-4">Try searching for:</p>
              <div className="flex flex-wrap gap-2 justify-center">
                {config.exampleSearches.map((example) => (
                  <button
                    key={example}
                    onClick={() => setSearchQuery(example)}
                    className="px-3 py-1 rounded-full bg-muted hover:bg-muted/80 transition-colors"
                  >
                    {example}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
